<h3>Seção de Carrossel de banners</h3>
<form class="form-b4a" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="carousel-section">
    <h4>Banners</h4>
    <div
      formArrayName="banners"
      cdkDropList
      (cdkDropListDropped)="onDrop($event)"
    >
      <div
        *ngFor="let banner of banners.controls; let i = index"
        [formGroupName]="i"
        class="banner-item p-card"
        cdkDrag
      >
        <div class="banner-content">
          <span class="image-upload">
            <div class="file-upload">
              <span class="p-float-label">
                <input
                  type="text"
                  readonly
                  pInputText
                  formControlName="mobileImage"
                  id="mobileImage{{ i }}"
                />
                <label for="mobileImage{{ i }}">
                  Imagem Mobile* - (Máx. 250kb / WEBP) Especifiações:
                  {{ mobileImageWidth }}x{{ mobileImageHeight }}
                </label>
              </span>
              <p-fileUpload
                mode="basic"
                chooseLabel="Selecionar"
                name="file"
                [auto]="true"
                accept=".webp"
                [maxFileSize]="250 * 1024"
                uploadIcon="pi pi-file"
                [customUpload]="true"
                (uploadHandler)="
                  onUpload(
                    $event,
                    'banners.' + i + '.mobileImage',
                    desktopUpload,
                    undefined,
                    true,
                    mobileImageWidth,
                    mobileImageHeight
                  )
                "
                id="mobileImage{{ i }}"
                #desktopUpload
              />
            </div>
            <img
              class="mobile-image-preview"
              *ngIf="form.value.banners[i].mobileImage"
              [src]="form.value.banners[i].mobileImage"
            />
          </span>

          <span class="image-upload">
            <div class="file-upload">
              <span class="p-float-label">
                <input
                  type="text"
                  readonly
                  pInputText
                  formControlName="desktopImage"
                  id="desktopImage{{ i }}"
                />
                <label for="desktopImage{{ i }}">
                  Imagem Desktop * - (Máx. 250kb / WEBP) Especifiações:
                  {{ desktopImageWidth }}x{{ desktopImageHeight }}
                </label>
              </span>
              <p-fileUpload
                mode="basic"
                chooseLabel="Selecionar"
                name="file"
                [auto]="true"
                accept=".webp"
                [maxFileSize]="250 * 1024"
                uploadIcon="pi pi-file"
                [customUpload]="true"
                (uploadHandler)="
                  onUpload(
                    $event,
                    'banners.' + i + '.desktopImage',
                    desktopUpload,
                    undefined,
                    true,
                    desktopImageWidth,
                    desktopImageHeight
                  )
                "
                id="desktopImage{{ i }}"
                #desktopUpload
              />
            </div>
            <img
              class="desktop-image-preview"
              *ngIf="form.value.banners[i].desktopImage"
              [src]="form.value.banners[i].desktopImage"
            />
          </span>

          <span class="p-float-label">
            <input
              type="url"
              pInputText
              formControlName="link"
              id="link{{ i }}"
              name="link"
            />
            <label for="link{{ i }}">Link *</label>
          </span>
          <span class="p-float-label">
            <input
              type="text"
              pInputText
              formControlName="altText"
              id="altText{{ i }}"
              name="altText"
            />
            <label for="altText{{ i }}">Alt Text *</label>
          </span>
          <span class="p-float-label">
            <input
              type="text"
              pInputText
              formControlName="countdown"
              id="countdown{{ i }}"
              name="countdown"
            />
            <label for="countdown{{ i }}">Countdown</label>
          </span>
          <span class="p-float-label">
            <p-calendar
              inputId="publishDate{{ i }}"
              dateFormat="dd/mm/yy"
              appendTo="body"
              formControlName="publishDate"
              [showTime]="true"
              [hourFormat]="24"
            />
            <label for="publishDate{{ i }}">Data de Publicação</label>
          </span>
          <span class="p-float-label">
            <p-calendar
              inputId="expirationDate{{ i }}"
              dateFormat="dd/mm/yy"
              appendTo="body"
              formControlName="expirationDate"
              [showTime]="true"
              [hourFormat]="24"
            />
            <label for="expirationDate{{ i }}">Data de Expiração</label>
          </span>
          <div class="w-full" style="grid-column: 1 / -1">
            <h4>Regras de Exibição</h4>
            <div
              class="displayRules"
              formGroupName="displayRules"
              style="
                display: grid;
                grid-template-columns: repeat(5, 1fr);
                gap: 10px;
              "
            >
              <div class="rule-group">
                <label>Assinante já comprou</label>
                <p-dropdown
                  formControlName="subscriberBuyer"
                  [options]="displayRuleOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Selecione"
                  appendTo="body"
                ></p-dropdown>
              </div>
              <div class="rule-group">
                <label>Não assinante</label>
                <p-dropdown
                  formControlName="notSubscriber"
                  [options]="displayRuleOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Selecione"
                  appendTo="body"
                ></p-dropdown>
              </div>
              <div class="rule-group">
                <label>Assinante nunca comprou</label>
                <p-dropdown
                  formControlName="subscriberNotBuyer"
                  [options]="displayRuleOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Selecione"
                  appendTo="body"
                ></p-dropdown>
              </div>
              <div class="rule-group">
                <label>Assinante top badge</label>
                <p-dropdown
                  formControlName="topBadgeSubscriber"
                  [options]="displayRuleOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Selecione"
                  appendTo="body"
                ></p-dropdown>
              </div>
            </div>
          </div>
        </div>

        <div class="banner-actions">
          <p-button
            type="button"
            icon="pi pi-arrows-alt"
            class="p-button-text p-button-rounded"
            pTooltip="Arrastar para reordenar"
          />
          <p-button
            type="button"
            icon="pi pi-trash"
            severity="danger"
            (click)="removeBanner(i)"
            class="p-button-sm remove-button"
          />
        </div>
      </div>
    </div>
    <p-button
      type="button"
      label="Adicionar Banner"
      icon="pi pi-plus"
      (click)="addBanner()"
      class="p-button-secondary"
    />
  </div>

  <span class="buttons">
    <p-button
      label="Voltar"
      severity="danger"
      routerLink="/configuracoes/mens/home"
    />
    <p-button label="Salvar" type="submit" [disabled]="!form.valid" />
  </span>
</form>
